<div class="megamenu garmentmenu bg-light rounded-5">
  <div class="">
    <div class="py-2 py-md-4 px-3 px-md-5 d-flex align-items-center justify-content-between">
      <span class="text-secondary">Notifications</span>
      <button *ngIf="notificationsList.length" class="btn btn-secondary fs-5" type="button" (click)="markRead()">
        Mark As Read
      </button>
    </div>
    <div class="p-3 bg-white m-2 rounded-5 mgzs">
      <div class="esc mb-0 notifcation-list">
        <ul>
          <li *ngFor="let data of notificationsList" [class.bg-body-tertiary]="!data.isRead"
            class="d-flex align-items-start gap-2 px-2 py-3">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                <path d="M6.75 7.5V4.5M10.5 7.5V4.5M14.25 0.75H0.75V12.75H4.5V15.75L7.5 12.75H11.25L14.25 9.75V0.75Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <div>
              <p class="title">
                {{getTypeMessage(data)}}
              </p>
              <p class="fs-5">{{data.message}}
              </p>
              <div>
                <button type="button" class="btn btn-link text-secondary p-0 fs-6"
                  (click)="goToLink(data)">{{linkMessage(data)}}</button>
              </div>
            </div>
            <div class="ms-auto">
              <span class="time">
                {{data.createdAt | date: 'h:mm a, MMM d, y'}}
              </span>
              <div class="d-flex align-items-center justify-content-end gap-2">
                <button (click)="remove(data.id)" class="btn btn-secondary-icon p-0 shadow-none" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984" stroke="#DF1C41"
                      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984"
                      stroke="url(#paint0_linear_2177_612263)" stroke-opacity="0.16" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round"></path>
                    <defs>
                      <linearGradient id="paint0_linear_2177_612263" x1="8.00039" y1="4.39844" x2="8.00039" y2="11.5984"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="white" stop-opacity="0"></stop>
                        <stop offset="1" stop-color="white"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </button>
              </div>
            </div>
          </li>
          <li class="px-4" *ngIf="!notificationsList.length">
            No New Notification!
          </li>
        </ul>
      </div>
    </div>
    <div class="py-2 py-md-4 px-3 px-md-5">
      <button class="btn btn-secondary" type="button" [routerLink]="['/account/notifications']">
        See All Notifications
      </button>
    </div>
  </div>
</div>